module.exports = __webpack_public_path__ + "img/easyuni_prod.613df1a1.png";